import { render, staticRenderFns } from "./UiNumberInput.vue?vue&type=template&id=a1dcf9e2"
import script from "./UiNumberInput.vue?vue&type=script&lang=js"
export * from "./UiNumberInput.vue?vue&type=script&lang=js"
import style0 from "./UiNumberInput.vue?vue&type=style&index=0&id=a1dcf9e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports